import { z } from 'zod';
import { baseEntityFields, idSchema } from './common.schema';
/**
 * Client — a per-customer sub-scope within a tenant (the MSP's customer).
 * Maps optionally to Dispatch (Proteus) customer/location identifiers so
 * alerts can create onsite Requests with geo data intact
 * (technical-architecture.md §4.2, dispatch-integration contract).
 */
export const dispatchLinkageSchema = z
    .object({
    serviceProviderId: idSchema,
    customerId: idSchema,
    customerLocationId: idSchema.optional(),
})
    .strict();
export const clientInputSchema = z
    .object({
    name: z.string().min(1).max(200),
    description: z.string().max(2000).optional(),
    contactEmail: z.string().email().optional(),
    dispatch: dispatchLinkageSchema.optional(),
})
    .strict();
/** Updates may clear nullable-at-rest fields with an explicit null. */
export const clientUpdateSchema = clientInputSchema
    .partial()
    .extend({
    description: z.string().max(2000).nullable().optional(),
    contactEmail: z.string().email().nullable().optional(),
    dispatch: dispatchLinkageSchema.nullable().optional(),
})
    .strict();
/** Stored shape: clearable optional fields are materialized as null. */
export const clientSchema = clientInputSchema
    .extend({
    description: z.string().max(2000).nullable(),
    contactEmail: z.string().email().nullable(),
    dispatch: dispatchLinkageSchema.nullable(),
})
    .extend(baseEntityFields)
    .strict();
//# sourceMappingURL=client.schema.js.map